"use strict";

define('view/table.selected.remove',['underscore', 'backbone', 'marionette', 'handlebars', 'uikit/elements/button', './table.selected.view'], function (_, Backbone, Mn, Handlebars, ButtonView, TableSelectedView) {
  var TableSelectedRemove = TableSelectedView.extend({
    initialize: function initialize() {
      TableSelectedView.prototype.initialize.apply(this, arguments);
      var buttonOptions = _.extend({}, this.buttonOptions, this.getOption('buttonOptions'));
      this.view = new ButtonView(_.extend({
        circular: true,
        icon: 'remove',
        size: 'small'
      }, buttonOptions));
      this.view.$el.addClass('invertable');
      this.view.on('press', function () {
        var row = this.getRow();
        row.trigger('remove:model', this);
      }, this);
    }
  });
  return TableSelectedRemove;
});

